import React from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxChecked from '@mui/icons-material/CheckBox';
import CheckBoxBlank from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

//import SignaturePad from '../Components/SignaturePad';
import UnterschriftHaken from '../Components/UnterschriftHaken';

import personEntity from '../Entity/person';
import ortEntity from '../Entity/ort';
//import signatureEntity from '../Entity/signature';
import HaltungsaenderungMetadaten from '../Entity/HaltungsaenderungMetadaten';
import Person from '../Components/Person';
import Ort from '../Components/Ort';
import Fehlerbox from '../Components/Fehlerbox';
import Creatures from '../Components/Creatures';
import MeldungWurdeVersandt from '../Components/MeldungWurdeVersandt';
import PretextHaltungsaenderung from '../Components/Hilfe/PretextHaltungsaenderung';

import Zoom from '@mui/material/Zoom';

import CreatureEntity from '../Entity/Creature';
import CreatureConfigFields from '../Entity/CreatureConfigFields';

import ValidatorPerson from '../Module/Validatoren/ValidatorPerson';
import ValidatorOrt from '../Module/Validatoren/ValidatorOrt';

import {updateValue, addEntityToState, removeEntityFromState, addCreature} from '../Actions';

const style = {
  paper: {
    padding:"10px 20px 10px 20px",
  },
  paperAktiv: {
    padding:"10px 20px 10px 20px",
  },
  checkboxItem: {
    paddingTop:"18px",
  },
}

const configCreatureExemplar = () => {
  let crtrConf = CreatureConfigFields()
  let crtr = CreatureEntity(crtrConf)
  return crtr;
}

const configHalter = (touched) => {
  let halter = personEntity(touched)
  halter.personTyp.display = true
  return halter;
}

const configHalterNeu = (touched) => {
  let halter = personEntity(touched)
  halter.personTyp.display = true
  return halter;
}

export default class FormularHaltungsaenderung extends React.Component {

  constructor (props) {
    super(props);
    this.props.data.HaltungsaenderungMetadaten = HaltungsaenderungMetadaten()
    this.props.data.halter = configHalter()
    this.props.data['dokumente'] = []
    //this.props.data.unterschriftHalter = signatureEntity()

  }

  checkbox = (value) => {
    if (value === true) {
        return <CheckBoxChecked/>
    }
    return <CheckBoxBlank/>
  }

  updateValue = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.value', value))
  }

  updateTouch = (pathGroupName) => (pathValueName) => () => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.touched', true))
  }

  updateValid = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.valid', value))
  }

  updateDisplay = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.display', value))
  }

  updateMsg = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.msg', value))
  }

  dispatchChoice = (pathGroupName) => (pathValueName) => (value) => {
    this.props.dispatch(updateValue(pathGroupName+'.'+pathValueName+'.value', value))
  }

  dispatchAddEntity = (entityStateName, entity)  => {
    this.props.dispatch(updateValue(entityStateName, entity))
  }

  renderChoiceHalterZiehtUm = () => {
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">Ändert sich die Anschrift oder andere Daten zum Halter?</FormLabel>
        <FormGroup aria-label="position" row>

          <FormControlLabel
            value="top"
            control={
              <Checkbox
                onChange={()=>{
                  this.updateValue('HaltungsaenderungMetadaten')('halterZiehtUm')(true)
                  this.props.dispatch( addEntityToState("halterNeu", configHalterNeu(this.props.data.meta.touched.value)) )
  
                }}
                checked={this.props.data.HaltungsaenderungMetadaten.halterZiehtUm.value===true}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
              />
            }
            label="Adresse oder Kontaktinformationen ändern sich"
            labelPlacement="end"
          />

          <FormControlLabel
            value="top"
            control={
              <Checkbox
                onChange={()=>{
                  if (this.props.data.HaltungsaenderungMetadaten.halterZiehtUm.value === true) {
                    if (!confirm("Gibt es keine Änderungen zur Person des Halters? Ihre neuen Angaben zum Halter werden gelöscht!"))
                    return;
                  }
                  this.updateValue('HaltungsaenderungMetadaten')('halterZiehtUm')(false)
                  this.props.dispatch(removeEntityFromState('halterNeu'))
                }}
                checked={this.props.data.HaltungsaenderungMetadaten.halterZiehtUm.value === false}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
              />
            }
            label="Keine Änderungen"
            labelPlacement="end"
          />

        </FormGroup>
      </FormControl>
    )
  }

  renderChoiceTiereZiehenUm = () => {
    return (
      <Paper style={style.paper}>

        <FormControl component="fieldset">
          <FormLabel component="legend">Ziehen gemeldete Tiere um?</FormLabel>
          <FormGroup aria-label="position" row>

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    if (this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value === "einige") {
                      if (!confirm("Ziehen alle Tiere um? In dem Fall werden alle gemeldeten Tiere umgezogen. Bereits eingegebene Tiere werden gelöscht!"))
                      return;
                    }
                    this.updateValue('HaltungsaenderungMetadaten')('tiereZiehenUm')("alle")
                    this.props.dispatch(removeEntityFromState('creatures'))
                  }}
                  checked={this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value==="alle"}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Alle gemeldeten Tiere ziehen um"
              labelPlacement="end"
            />

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    if (this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value === "einige") {
                      if (!confirm("Ziehen keine Tiere um? In dem Fall sind keine Angaben zu einzelnen Tieren erforderlich. Bereits eingegebene Tiere werden gelöscht!"))
                      return;
                    }
                    this.updateValue('HaltungsaenderungMetadaten')('tiereZiehenUm')("keine")
                    this.props.dispatch(removeEntityFromState('creatures'))
                  }}
                  checked={this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value === "keine"}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label={<span>Es ziehen <u>keine</u> Tiere um</span>}
              labelPlacement="end"
            />

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    this.updateValue('HaltungsaenderungMetadaten')('tiereZiehenUm')("einige")
                    this.props.dispatch(
                      addEntityToState('creatures', {})
                    )
                    this.props.dispatch(
                      addCreature(configCreatureExemplar())
                    )
                  }}
                  checked={this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value==="einige"}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Einige Tiere ziehen um"
              labelPlacement="end"
            />

          </FormGroup>
        </FormControl>

      </Paper>
    )
  }

  renderChoiceHaltungsort = () => {
    return (
      <Paper style={style.paper}>

        <FormControl component="fieldset">
          <FormLabel component="legend">Ist der Wohnort des Halters mit dem Ort der Haltung identisch?</FormLabel>
          <FormGroup aria-label="position" row>

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    if (this.props.data.HaltungsaenderungMetadaten.wohnortIstHaltungsort.value === false) {
                      if (!confirm("Wollen Sie angeben, dass die Tiere bei Ihnen zuhause gehalten werden? Ihre Angaben zum abweichenden Haltungsort werden gelöscht!"))
                      return;
                    }
                    this.updateValue('HaltungsaenderungMetadaten')('wohnortIstHaltungsort')(true)
                    this.props.dispatch(removeEntityFromState('haltungsort'))
                  }}
                  checked={this.props.data.HaltungsaenderungMetadaten.wohnortIstHaltungsort.value === true}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Haltungsort ist mit dem Wohnort identisch"
              labelPlacement="end"
            />

            <FormControlLabel
              value="top"
              control={
                <Checkbox
                  onChange={()=>{
                    this.updateValue('HaltungsaenderungMetadaten')('wohnortIstHaltungsort')(false)
                    this.props.dispatch(
                      addEntityToState(
                        'haltungsort',
                        ortEntity(this.props.data.meta.touched.value)
                      )
                    )
                  }}
                  checked={this.props.data.HaltungsaenderungMetadaten.wohnortIstHaltungsort.value === false}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                />
              }
              label="Haltungsort weicht vom Wohnort ab"
              labelPlacement="end"
            />

          </FormGroup>
        </FormControl>

        {this.props.data.hasOwnProperty('haltungsort') &&
          <Zoom in={this.props.data.hasOwnProperty('haltungsort')} timeout={500}>
          <div>
            <Ort
              id="NeuerHaltungsort"
              headline="Neuer Haltungsort"
              data={this.props.data.haltungsort}
              updaterValue={this.updateValue('haltungsort')}
              updaterTouch={this.updateTouch('haltungsort')}
              updaterValid={this.updateValid('haltungsort')}
              restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
            />


            <Fehlerbox
              inhalt={this.validatorHaltungsortResult(this.props.data.haltungsort)}
            />
          </div>
          </Zoom>
        }

      </Paper>
    )
  }

/*
  signature = (group, beschriftung = null) => {
    if (!this.props.data.hasOwnProperty(group) ) {
      return 
    }
    return (
      <SignaturePad 
        data={this.props.data[group]}
        updateSvg={(value)=>this.props.dispatch(updateValue(group+'.svg', value))}
        updateShowPad={(value)=>this.props.dispatch(updateValue(group+'.showPad', value))}
        beschriftung={beschriftung}
      />
    )

  }
*/

  touchAll = (obj, group) => {
    for (let item in obj) {
      if (obj[item].hasOwnProperty("touched")) {
        this.updateTouch(group)(item)()
      }
    }
  }

  validatorPersonResult = (person, checkPersoPass=false) => {

    if (!person.meta.touched) {
      return []
    }

    var res = ValidatorPerson(person, checkPersoPass)
    if ( res.valid === true ) {
      return [];
    }

    var display = [];
    res.message.map(
    (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;

  }

  validatorHaltungsortResult = (haltungsort) => {
    if (!haltungsort.meta.touched) {
      return []
    }

    var res = ValidatorOrt(haltungsort)

    if ( res.valid === true ) {
      return [];
    }
    var display = [];
    res.message.map(
      (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;
  }

  buttonPruefen = (label) => (
    <Button
      onClick={()=>{
        this.updateValue("meta")("touched")(true)
        if (this.props.data.hasOwnProperty("haltungsort")) {
          this.touchAll(this.props.data.haltungsort, 'haltungsort')
        }
        if (this.props.data.hasOwnProperty("halter")) {
          this.touchAll(this.props.data.halter, 'halter')
        }
        if (this.props.data.hasOwnProperty("halterAlt")) {
          this.touchAll(this.props.data.halterAlt, 'halterAlt')
        }
        if (this.props.data.hasOwnProperty("halterNeu")) {
          this.touchAll(this.props.data.halterNeu, 'halterNeu')
        }

        if (
          this.props.data.hasOwnProperty("creatures") 
          && Object.keys(this.props.data.creatures).length > 0
        ) {
          Object.keys(this.props.data.creatures).map(
            (element, key) => {
              this.touchAll(this.props.data.creatures[element], "creatures."+element)
            }
          )
        }
        
      }}
      variant="contained"
      color="primary"
      size="large"
      fullWidth={true}
    >
      &nbsp;<br/> {label}<br/>&nbsp;
    </Button>
  )

  absenden = () => {

    if (this.props.data.meta.touched.value !== true) {
      return this.buttonPruefen("Angaben Prüfen");
    }

    var msg = []

    if (this.props.data.HaltungsaenderungMetadaten.halterZiehtUm.value === null) {
      msg.push(
        <p key="ERR.halterZiehtUm">
          Bitte angeben: Ändert sich die Anschrift oder andere Informationen zum Halter?
        </p>
      )
    }

    if (!this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value) {
      msg.push(
        <p key="ERR.tiereZiehenUm">
          Bitte angeben: Ziehen gemeldete Tiere um?
        </p>
      )
    }

    if (this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value === false && 
      this.props.data.HaltungsaenderungMetadaten.halterZiehtUm.value === false) {
      msg.push(
        <p key="ERR.tiereZiehenUmA">
          Sie haben angegeben, dass sich weder Daten zum Halter noch der Aufenthaltsort von gemeldeten Tieren ändert.<br/>
          Für die Anzeige eines Haltungsortwechsels oder Wohnortwechsels muss mindestens eines zutreffen.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("haltungsort") &&
      !ValidatorOrt(this.props.data.haltungsort).valid 
    ) {
      msg.push(
        <p key="ERR.HOrt">
          Fehler beim Haltungsort. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("halter") &&
      !ValidatorPerson(this.props.data.halter).valid 
    ) {
      msg.push(
        <p key="ERR.Halter">
          Fehler bei Angaben zum Halter. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("halterAlt") &&
      !ValidatorPerson(this.props.data.halterAlt).valid 
    ) {
      msg.push(
        <p key="ERR.Halter_Alt">
          Fehler bei Angaben zum Halter (Alt). Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("halterNeu") &&
      !ValidatorPerson(this.props.data.halterNeu).valid 
    ) {
      msg.push(
        <p key="ERR.Halter_Neu">
          Fehler bei Angaben zum Halter (Neu). Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("unterschriftHalter") &&
      !this.props.data.unterschriftHalter.svg 
    ) {
      msg.push(
        <p key="ERR.SignaturHalter">
          Bitte unterschreiben Sie vor Abgabe
        </p>
      )
    }

    let countCreatures = 0;
    for (let index in this.props.data.creatures) {
      countCreatures++
      if (
        this.props.data.creatures[index].hasOwnProperty("spezies")
        && (
          !this.props.data.creatures[index].spezies.hasOwnProperty("wiss")
          || this.props.data.creatures[index].spezies.wiss == ""
        )
      ) {
        msg.push(
          <p key={"ERR.Spec"+index}>
            Für das {countCreatures}. Tier wurde die Spezies nicht korrekt ausgewählt.
          </p>
        )
      }
    }

    if ( 
      this.props.data.meta.unterschrifthaken.value !== true
    ) {
      msg.push(
        <p key="ERR.UnterschriftHaken">
          Bitte bestätigen Sie, dass Ihre Angaben richtig und vollständig sind.
        </p>
      )
    }

    if (msg.length < 1) {
      return this.props.absenden(
        "Jetzt rechtsverbindlich einreichen/abschicken.",
        false,
        ()=>{
          this.updateValue('meta')('wurdeVersandt')(true)
        }
        
        )
    } else {
      return (
        <div>
          <Fehlerbox
            inhalt={msg}
          />
          <div style={{marginTop:"25px"}}></div>
          {this.props.absenden(
            "Jetzt rechtsverbindlich einreichen/abschicken.", 
            true,
            ()=>{
              this.updateValue('meta')('wurdeVersandt')(true)
            }
          )}
        </div>
      )
    }

  }

  render = () => {
    if (this.props.data.meta.wurdeVersandt.value) {
      return (
        <MeldungWurdeVersandt>
          Die Änderungsmitteilung wurde erfolgeich versandt.
        </MeldungWurdeVersandt>
      );
    }

    return (
      <div>
        {this.props.titel}

        <div style={{marginTop:"25px"}}></div>

        <PretextHaltungsaenderung />

        <div style={{marginTop:"25px"}}></div>

        <Paper style={style.paper}>

          {this.props.data.hasOwnProperty('halter') &&
            <div>
              <Person
                id="PersonHalter"
                headline={
                  this.props.data.hasOwnProperty('halterNeu')
                  ?<span>Alte Angaben zum Halter</span>
                  :<span>Halter</span>
                }
                withCard={false}
                data={this.props.data.halter}
                updaterValue={this.updateValue('halter')}
                updaterTouch={this.updateTouch('halter')}
                updaterValid={this.updateValid('halter')}
                updaterMsg={this.updateMsg('halter')}
                restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
                konfiguration = {this.props.konfiguration.importierteKonfiguration.halter}
                
              />

              <Fehlerbox
                inhalt={this.validatorPersonResult(this.props.data.halter, true)}
              />
            </div>
          }

          <div style={{marginTop:"25px"}}></div>

          {this.renderChoiceHalterZiehtUm()}

          {this.props.data.hasOwnProperty('halterNeu') &&
            <Zoom in={this.props.data.hasOwnProperty('halterNeu')} timeout={500}>
            <div>
              <Person
                id="PersonHalterNeu"
                headline="Neue Angaben zum Halter"
                withCard={false}
                data={this.props.data.halterNeu}
                updaterValue={this.updateValue('halterNeu')}
                updaterTouch={this.updateTouch('halterNeu')}
                updaterValid={this.updateValid('halterNeu')}
                updaterMsg={this.updateMsg('halterNeu')}
                restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
                konfiguration = {this.props.konfiguration.importierteKonfiguration.halter}
              />

              <Fehlerbox
                inhalt={this.validatorPersonResult(this.props.data.halterNeu, true)}
              />
            </div>
            </Zoom>
          }

        </Paper>

        <div style={{marginTop:"25px"}}></div>

        {this.renderChoiceTiereZiehenUm()}

        {(this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value == "alle" || this.props.data.HaltungsaenderungMetadaten.tiereZiehenUm.value == "einige")  &&
          <div  style={{marginTop:"25px"}}>
            {this.renderChoiceHaltungsort()}
          </div>
        }

        <div style={{marginTop:"25px"}}></div>

        {this.props.data.hasOwnProperty("creatures") &&
          <div>
            <h2>Welche Exemplare ziehen um?</h2>
            <Creatures
              form={this.props.form}
              data={this.props.data}
              creatures={this.props.data.creatures}
              dispatch={this.props.dispatch}
              updaterValue={this.updateValue}
              updaterTouch={this.updateTouch}
              updaterValid={this.updateValid}
              konfiguration={this.props.konfiguration}
              creatureExemplar={configCreatureExemplar}
              creatureParent={null}
              creatureNachkommen={null}
              restLadeSpezies={this.props.konfiguration.restPath + 'spezies.php'}
              restPath={this.props.konfiguration.restPath}
              kennzeichnungAnpassen={true}
            />
          </div>
        }


        {this.props.data.hasOwnProperty("dokumente") && 1==2 &&
          <div>
            <div style={{marginTop:"25px"}}></div>
            <Paper style={style.paper}>
            <h2>Versicherungsnachweis</h2>
            <p>
              Text zum Versicherugsnachweis
            </p>
            <p>
              Ansonsten können Sie den Nachweis auch nachreichen.
              Dies geht ebenfalls online hier auf <b>Gifttiergesetz.de</b>.
            </p>
            <div style={{marginTop:"25px"}}></div>
            {this.props.dokumente}
            <div style={{marginTop:"25px"}}></div>
            </Paper>
          </div>
        }

        <div style={{marginTop:"25px"}}></div>

        {this.props.hinweise}

        
        {/*this.props.data.hasOwnProperty("unterschriftHalter") &&
          <div style={{marginTop:"25px"}}>
            {this.signature("unterschriftHalter", "Unterschrift Halter/in")}
          </div>
      */}



        <div style={{marginTop:"25px"}}></div>

        <UnterschriftHaken 
          value={this.props.data.meta.unterschrifthaken.value}
          update={this.updateValue("meta")("unterschrifthaken")}
        />


        {this.absenden()}

        {this.props.data.meta.wurdeVersandt.value&&
          this.props.followup
        }

      </div>
    )
  }

}